// extracted by mini-css-extract-plugin
module.exports = {"hero":"labyrinth_hero__ByMza","code":"labyrinth_code__onfeh","stacks":"labyrinth_stacks__GMNpN","stack":"labyrinth_stack__JSd6X","stackName":"labyrinth_stackName__bLWZh"};